<template>
    <el-input
        v-model.trim="mobile"
        :placeholder="t('login.input1')"
        type="number"
        autocomplete="off"
        size="large"
        :style="{ '--el-input-text-color': '#333' }"
        oninput="this.value=this.value.slice(0,20)"
        onwheel="event.preventDefault()"
    >
        <template #prepend>
            <el-select
                popper-class="common-popper mobild-input-popper"
                placeholder="+86"
                v-model="region"
                :disabled="disabledCountry"
                class="!w-110"
                @visible-change="handleVisibleChange"
            >
                <template #label="{ label, value }">
                    <span class="!w-30 mr-8" :class="[`fi fi-${label.toLowerCase()}`]"></span>
                    <span>{{ value }}</span>
                </template>
                <div class="absolute top-0 left-0 w-full bg-#fff z-1">
                    <el-input
                        v-model.trim="searchCountry"
                        class="p-[5px_20px_5px_24px] text-14"
                        clearable
                        @input="handleSearchCountry"
                        :placeholder="t('login.input3')"
                    ></el-input>
                </div>
                <el-option
                    v-for="(item, index) in displayCountry"
                    :key="item.countryCode"
                    :label="item.countryCode"
                    :value="item.phoneCode"
                    :disabled="item.disabled"
                >
                    <div v-if="!item.label" class="flex items-center min-w-280">
                        <span class="!w-30" :class="[`fi fi-${item.countryCode.toLowerCase()}`]"></span>
                        <span class="mx-8">{{ currentLocale === 'en' ? item.englishName : item.chineseName }}</span>
                        <span>{{ item.phoneCode }}</span>
                    </div>
                    <div class="min-w-307 pl-4 text-#999" v-else>{{ item.label }}</div>
                </el-option>
            </el-select>
        </template>
    </el-input>
</template>
<script lang="ts" setup>
import country from '@/const/country';
import { useI18n } from 'vue-i18n';

const { currentLocale } = useStore('locale');
const { t } = useI18n();

export interface Props {
    disabledCountry?: boolean;
}
withDefaults(defineProps<Props>(), {  })
let mobile = defineModel('mobile', { type: String });
let region = defineModel('region', { type: String });
let searchCountry = ref('');
let displayCountry = ref(country);

function handleVisibleChange(val: boolean) {
    searchCountry.value = '';
    if (val) {
        displayCountry.value = country;
    }
}
function handleSearchCountry(val: string) {
    if (val) {
        let result = country.filter((item: any) => {
            if(currentLocale.value === 'en'){
                return item.englishName.toLowerCase().includes(val.toLocaleLowerCase())
            } else {
                return item.chineseName.toLowerCase().includes(val.toLocaleLowerCase())
            }
        });
        if (result.length <= 0) {
            result = [{ label: t('common.noData'), disabled: true }];
        }
        displayCountry.value = result;
    } else {
        displayCountry.value = country;
    }
}
</script>
<style lang="scss">
.mobild-input-popper {
    .el-select-dropdown__wrap {
        padding-top: 35px;
    }
}
</style>
